var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"text-center mx-auto text--secondary"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }